export enum EReviewsSort {
  NEW_FIRST = 'NEW_FIRST',
  OLD_FIRST = 'OLD_FIRST',
  HIGH_GRADE_FIRST = 'HIGH_GRADE_FIRST',
  LOW_GRADE_FIRST = 'LOW_GRADE_FIRST',
}
export interface IClubReviewsRequest {
  input: {
    user_uuid: string | null;
    sort: EReviewsSort | null;
  };
  page?: number;
}
export interface IClubReviewsResponse {
  clubComments: {
    paginatorInfo: {
      count: number;
      currentPage: number;
      lastPage: number;
    };
    summary: {
      average_grade: number;
      unread_total: number;
      five: number;
      four: number;
      three: number;
      two: number;
      one: number;
    };
    data: Array<{
      id: number;
      text: string;
      author?: {
        uuid: string;
        nickname: string;
        phone: string;
      };
      created_at: string;
      host_alias: string;
      host_group_name: string;
      grade: number;
      is_read: boolean;
      request_contact?: boolean;
      request_contact_info?: string;
      tips: number | null;
      worker_name: string | null;
    }>;
  };
}

export interface IReadClubReviewRequest {
  id: number;
}
export interface IReadClubReviewResponse {
  readClubComment: {
    id: number;
    is_read: boolean;
  };
}

export interface IReadAllClubReviewsResponse {
  readAllClubComments: boolean;
}

export interface IReviewsCountResponse {
  clubComments: {
    summary: {
      unread_total: number;
    };
  };
}
